module.exports = new __parcel__URL__("80_180mm.66f13928.png").toString();